import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Ser1.css";

import aiImg from "../assets/assets/ai-ml.jpg";
import cloudImg from "../assets/assets/cloud-devops.jpg";
import edutechImg from "../assets/assets/edutech.jpg";
import softwareImg from "../assets/assets/custom-software.jpg";
import supportImg from "../assets/assets/support.jpg";
import cyberImg from "../assets/assets/cybersecurity.jpg";
import testingImg from "../assets/assets/software-testing.jpg";

const ServicesCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(2);

  const services = [
    {
      title: "Custom Software Development",
      description:
        "Custom software development and engineering services tailored to your specific business requirements.",
      image: softwareImg,
      slug: "software-engineering",
    },
    {
      title: "Artificial Intelligence & Machine Learning",
      description:
        "Intelligent solutions powered by AI and Machine Learning to transform your business operations.",
      image: aiImg,
      slug: "artificial-intelligence",
    },
    {
      title: "Cloud Infrastructure & DevOps",
      description:
        "Scalable cloud infrastructure and streamlined DevOps practices for efficient deployment and operations.",
      image: cloudImg,
      slug: "cloud-devops",
    },
    {
      title: "Professional Software Training",
      description:
        "Career-focused training programs and hands-on trainings designed to upskill students and professionals.",
      image: edutechImg,
      slug: "internship-training",
    },
    {
      title: "Web & Mobile App Development",
      description:
        "Design, build, and scale modern web and mobile applications with delightful UX, secure architecture, and rapid delivery.",
      image: supportImg,
      slug: "web-mobile-apps",
    },
    {
      title: "Cybersecurity & Data Protection",
      description:
        "Comprehensive cybersecurity solutions to protect your business from threats and ensure data security.",
      image: cyberImg,
      slug: "cyber-security",
    },
    {
      title: "Software Quality & Testing",
      description:
        "Thorough software testing services to ensure quality, reliability, and performance of your applications.",
      image: testingImg,
      slug: "software-testing",
    },
  ];

  // Auto-advance cards slowly every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % services.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [services.length]);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? services.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % services.length);
  };

  const handleServiceClick = (e, serviceSlug) => {
    e.stopPropagation();
    window.location.href = `/services/${serviceSlug}`;
  };

  return (
    <section className="tech-coverflow-section">
      <div className="tech-coverflow-wrapper">
        <div className="tech-coverflow-header">
          <h2 className="tech-coverflow-title">Our Focused Technologies</h2>
        </div>

        {/* 3D Perspective Coverflow Carousel Stage */}
        <div className="coverflow-stage-container">
          <button
            className="coverflow-nav-btn coverflow-prev-btn"
            onClick={handlePrev}
            aria-label="Previous service"
          >
            <FaChevronLeft />
          </button>

          <div className="coverflow-track">
            {services.map((service, index) => {
              let offset = index - activeIndex;
              const total = services.length;

              if (offset > total / 2) offset -= total;
              if (offset < -total / 2) offset += total;

              const isActive = offset === 0;

              return (
                <div
                  key={`${service.slug}-${index}`}
                  className={`coverflow-card ${isActive ? "card-active" : ""}`}
                  style={{
                    "--offset": offset,
                    "--abs-offset": Math.abs(offset),
                    zIndex: 100 - Math.abs(offset),
                  }}
                  onClick={() => setActiveIndex(index)}
                >
                  {/* Card Upper Image Area */}
                  <div className="coverflow-card-image-box">
                    <img src={service.image} alt={service.title} />
                  </div>

                  {/* Card Content Area */}
                  <div className="coverflow-card-content">
                    <h3 className="coverflow-card-title">{service.title}</h3>
                    <p className="coverflow-card-description">
                      {service.description}
                    </p>

                    {isActive && (
                      <button
                        className="coverflow-card-learn-btn"
                        onClick={(e) => handleServiceClick(e, service.slug)}
                      >
                        Learn More
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className="coverflow-nav-btn coverflow-next-btn"
            onClick={handleNext}
            aria-label="Next service"
          >
            <FaChevronRight />
          </button>
        </div>

        {/* Pagination Dots Indicator */}
        <div className="coverflow-dots">
          {services.map((_, dotIdx) => (
            <button
              key={dotIdx}
              className={`coverflow-dot ${dotIdx === activeIndex ? "dot-active" : ""
                }`}
              onClick={() => setActiveIndex(dotIdx)}
              aria-label={`Go to slide ${dotIdx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesCarousel;
